import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Link, Paper, Typography } from '@mui/material';

import { imgLinks } from '../../shared';
import { PAYMENT_STATUS } from '../../shared/paymentStatus';

import PaymentStatus from './PaymentStatus';

import {
  StyledPaymentItemContainer,
  StyledPaymentItemIcon,
  StyledVerticalInternalContent,
} from './PaymentDetails.styled';

const imageStatus = (status) => {
  switch (status) {
    case 'failed':
    case 'blocked':
    case 'cancelled':
      return 'icon.failed';
    case 'paid':
      return 'icon.tick';
    case 'exportable':
    case 'upcoming':
    case 'exported':
      return 'confirm.time';
    case 'refunded':
    case 'refundable':
      return 'flying.money';
    default:
      return 'icon.failed';
  }
};

function PaymentItem(props) {
  const { payment } = props;

  const intl = useIntl();

  const {
    status,
    billingMonth,
    amountCents,
    policyAmountCents,
    addonAmountCents,
    collectAiClaimLink,
  } = payment || {};

  return (
    <Paper>
      <StyledPaymentItemContainer>
        <StyledVerticalInternalContent>
          <Typography variant="h3">
            {intl.formatDate(billingMonth, {
              year: 'numeric',
              month: 'long',
            })}
          </Typography>

          {Number.isInteger(amountCents) && (
            <Typography variant="p">
              <FormattedMessage id="payment.status.total_premium" />
              :&nbsp;
              {intl.formatNumber(amountCents / 100, { style: 'currency', currency: 'EUR' })}
            </Typography>
          )}

          {Number.isInteger(addonAmountCents) && addonAmountCents > 0 && (
            <Typography variant="p">
              {Number.isInteger(policyAmountCents) && (
                <>
                  {`${intl.formatNumber(policyAmountCents / 100, { style: 'currency', currency: 'EUR' })} `}
                  <FormattedMessage id="payment.status.policy_premium" />
                </>
              )}
              &nbsp;
              {`+ ${intl.formatNumber(addonAmountCents / 100, { style: 'currency', currency: 'EUR' })} `}
              <FormattedMessage id="policies.addons.im_coverage" />
            </Typography>
          )}

          <PaymentStatus status={status} />

          {status === PAYMENT_STATUS.FAILED && (
            <Link variant="p" href={collectAiClaimLink}>
              <FormattedMessage id="payment.failed.re.payment.link" />
            </Link>
          )}
        </StyledVerticalInternalContent>

        <StyledPaymentItemIcon src={imgLinks[imageStatus(status)]} alt="payment status" />
      </StyledPaymentItemContainer>
    </Paper>
  );
}

PaymentItem.propTypes = {
  payment: PropTypes.shape({
    status: PropTypes.string,
    billingMonth: PropTypes.string,
    amountCents: PropTypes.number,
    policyAmountCents: PropTypes.number,
    addonAmountCents: PropTypes.number,
    collectAiClaimLink: PropTypes.string,
    executeAt: PropTypes.string,
  }).isRequired,
};

export default PaymentItem;
